<template>
  <button type="button" class="adaptive-color-button">
    <span class="adaptive-color-button__background" :style="{ background: color }"></span>

    <span class="adaptive-color-button__content">
      <CloseIcon16 />
    </span>
  </button>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import CloseIcon16 from '@components/Icons/CloseIcon16.vue';

export default defineComponent({
  name: 'AdaptiveColorButton',

  components: {
    CloseIcon16,
  },

  props: {
    color: {
      type: String,
      default: null,
    },
  },
});
</script>

<style lang="scss">
@use 'settings/colors';
@use 'settings/settings';
.adaptive-color-button {
  border: none;
  outline: none;
  cursor: pointer;
  height: 24px;
  min-width: 24px;
  border-radius: settings.$border-radius;
  transition: all 0.1s ease-in-out;
  white-space: nowrap;
  position: relative;
  overflow: hidden;

  font-size: 12px;
  font-weight: 500;
  line-height: 20px;

  color: colors.$color-grey-800;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 2px 3px;
  &:not(:disabled) {
    &:focus {
      box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.2), settings.$box-shadow-focus;
    }

    &:hover .adaptive-color-button__background {
      filter: brightness(0.95);
    }
  }

  &:disabled {
    background: colors.$color-blue-300;
  }
}

.adaptive-color-button__background {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  transition: all 0.1s ease-in-out;
}

.adaptive-color-button__content {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .code-pill & {
    color: colors.$color-white;
  }
}
</style>
